<template>
    <div class="content-wrapper">
        <app-breadcrumb :page-title="$t('settings')" :directory="$t('ui_elements')" :icon="'trello'"/>

        <div class="mb-primary">
            <app-tab :tabs="tabsVertical" :icon="icon"/>
        </div>
    </div>
</template>

<script>
    import CopyButton from "../../../Demo/UI/CopyButton";

    export default {
        name: "Tabs",
        components: {CopyButton},
        data() {
            return {
                icon: 'settings',
                tabsVertical: [
                    {
                        "name": "Ticket Agents",
                        "title": "Ticket Agents",
                        "component": "tickets-settings-agent",
                        "permission": ""
                    },
                    {
                        "name": "Ticket Types",
                        "title": "Ticket Types",
                        "component": "tickets-settings-type",
                        "permission": ""
                    },
                    {
                        "name": "Ticket Channel",
                        "title": "Ticket Channel",
                        "component": "tickets-settings-channel",
                        "permission": ""
                    },
                    {
                        "name": "Reply Templates",
                        "title": "Reply Templates",
                        "component": "tickets-settings-reply",
                        "permission": ""
                    },
                ],

             tabsVerticalValue: `<app-tab :tabs="[
                    {
                        "name": "Ticket Agents",
                        "title": "Ticket Agents",
                        "component": "tab-setting",
                        "permission": ""
                    },
                    {
                        "name": "Ticket Types",
                        "title": "Ticket Types",
                        "component": "tab-setting",
                        "permission": ""
                    },
                    {
                        "name": "Ticket Channel",
                        "title": "Ticket Channel",
                        "component": "tab-setting",
                        "permission": ""
                    },
                    {
                        "name": "Reply Templates",
                        "title": "Reply Templates",
                        "component": "tab-setting",
                        "permission": ""
                    },
                ]" :icon="icon"/>`
            }
        }
    }
</script>
